<template>
    <section class="content">
      <div class="loading-overlay" v-if="loading">
      <div class="spinner"></div>
      <h4>Loading Data...</h4>
    </div>
      <div class="box box-info">
        <!-- <div class="p-toolbar p-component mb-4"> -->
          <crmFollowUpDetailsDialog ref="openDialog" :showNewButton="false"/>
        <DataTable ref="po"
          :value="crmFollowUpLists"
          :paginator="true"
          :rows="100" 
          :rowsPerPageOptions="[100, 500, 1000]"
          :filters="filters"
          class="p-datatable-responsive p-datatable-customers"
          :selection.sync="selectedProduct1" selectionMode="single"
        >
        <template #header v-if="this.$store.getters.modules.includes('5.38')">
            <div style="text-align: left">
              <Button icon="pi pi-external-link" label="Export" @click="exportCSV($event)" />
            </div>
          </template>
          <Column header="S.n">
            <template #body="slotProps">
            {{slotProps.index+1}}
            </template>
          </Column>
          <Column :sortable="true" header="Particular" field="particular" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['particular']" />
            </template>
          </Column>
          <Column :sortable="true" header="Client Name" field="clientName" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['clientName']" />
            </template>
          </Column>
          <Column :sortable="true"
            header="Contact Person"
            field="contactPerson"
            filterMatchMode="contains"
          >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['contactPerson']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Address" field="address" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['address']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Contact Number" field="contactNumber"
            filterMatchMode="contains" >
            <template #body="slotProps">
          {{ formatContactNumber(slotProps.data.contactNumber) }}
        </template>
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['contactNumber']" />
            </template>
          </Column>

          <Column :sortable="true" header="Remarks-Product-Rate" field="remarks" filterMatchMode="contains" >
            <template #body="slotProps">
            <Button icon="pi pi-eye" class="p-button-raised p-button-success" @click="openRemarks(slotProps.data)" />
            </template>
        </Column>
  
          <Column :sortable="true" header="Email" field="gmail" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['gmail']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Customer Type" field="customerType" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['customerType']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Priority" field="priority" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['priority']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Stage" field="stage" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['stage']" />
            </template>
          </Column>
  
          <Column :sortable="true" header="Sample Sent" field="sampleQuotationSent" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['sampleQuotationSent']" />
            </template>
            <template #body="slotProps">
    {{ slotProps.data.sampleQuotationSent ? 'Yes' : 'No' }}
  </template>
          </Column>

          <Column :sortable="true" header="Quotation Sent" field="quotationSent" filterMatchMode="contains" >
            <template #filter>
              <InputText type="text" class="p-column-filter" v-model="filters['quotationSent']" />
            </template>
            <template #body="slotProps">
    {{ slotProps.data.quotationSent ? 'Yes' : 'No' }}
  </template>
          </Column>

          <Column :sortable="true" header="Updated Date Np" field="updateDateNepali" filterMatchMode="contains" >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['updateDateNepali']" />
          </template>
        </Column>

          <Column :sortable="true" header="Next Follow Up Date Np" field="nextFollowUpDateNepali" filterMatchMode="contains" >
          <template #filter>
            <InputText type="text" class="p-column-filter" v-model="filters['nextFollowUpDateNepali']" />
          </template>
        </Column>
        <Column header="Enter By" :sortable="true" field="enterBy" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['enterBy']"/>
                </template>
              </Column>
              <Column header="Update By" :sortable="true" field="updatedBy" filterMatchMode="contains">
                <template #filter>
                  <InputText type="text" class="p-column-filter" v-model="filters['updatedBy']"/>
                </template>
              </Column>
  
          <Column header="Action" headerStyle="width: 11em">
            <template #body="slotProps">
              <!-- <Button icon="pi pi-eye" class="p-button-raised p-button-success" @click="editCrmFollowUp(slotProps.data)" />  -->
              <Button icon="pi pi-pencil" class="p-button-raised p-button-success" @click="editCrmFollowUp(slotProps.data)" />
            </template>
          </Column>
        </DataTable>
      </div>
      <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteCrmFollowUp"/>
      <remarksDialog
    :visible="dialogVisible"
    :style="{ width: '500px' }"
    header="Remarks"
    :modal="true"
    class="p-fluid"
  >
  <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-6">
        <label for="productName">Products <span style="color:red"></span></label>
        <Textarea
          id="productName"
          v-model="productName"
          rows="2"
          autoResize
        />
      </div>

   
      <div class="p-field p-col-12 p-md-6">
        <label for="rate">Rate <span style="color:red"></span></label>
        <Textarea
          id="rate"
          v-model="rate"
          rows="2"
          autoResize
        />
      </div>
    </div>
    <div class="p-fluid p-formgrid p-grid">
      <div class="p-field p-col-12 p-md-6">
        <label for="remarks">Remarks <span style="color:red"></span></label>
        <Textarea
          id="remarks"
          v-model="remarks"
          rows="3"
          autoResize
        />
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="remarks1">Remarks 1</label>
        <Textarea
          id="remarks1"
          v-model="remarks1"
          rows="3"
          autoResize
        />
      </div>
      <div class="p-field p-col-12 p-md-6">
        <label for="remarks2">Remarks 2</label>
        <Textarea
          id="remarks2"
          v-model="remarks2"
          rows="3"
          autoResize
        />
      </div>
    </div>
    <template #footer>
      <Button
        label="Close"
        icon="pi pi-times"
        class="p-button p-button-raised p-button-danger"
        @click="closeRemarks"
      />
    </template>
  </remarksDialog>
    </section>
  </template>
  
  <script>
  import crmFollowUpDetailsDialog from '../crmDialog/crmFollowUpDetailsDialog.vue'
  import Column from 'primevue/column'
  import DataTable from 'primevue/datatable'
  import Dialog from '../../layout/dialog'
  // import globalKey from '../../../store/globalKey'
  // import axios from 'axios'
  import InputText from 'primevue/inputtext'
  import Button from 'primevue/button'
  import remarksDialog from 'primevue/dialog'
  import Textarea from 'primevue/textarea'
  
  export default {
    name: 'followUpList',
    data() {
      return {
        displayBasic: false,
        dialogShow: false,
        columnList: '',
        accountId: null,
        loading: true,
        filters: {},
        remarks: '',
        remarks1: '',
        remarks2: '',
        dialogVisible: false,
        selectedProduct1: null,
        productVisible: false,
        productName: '',
        rate: ''
      }
    },
    computed: {
      crmFollowUpLists() {
        return this.$store.state.crm.crmFollowUpLists
      }
    },
    mounted() {
      this.crmFollowUpList()
      this.columnNames()
    },
    methods: {
      async deleteCrmFollowUp(value) {
        if (value.trim() === '') {
          this.$toast.add({severity: 'error', summary: '', detail: 'Delete reason cannot be empty!', life: 10000})
          this.dialogShow = true
          return
        }
        let deleteRe = {
          id: this.accountId,
          deleteReason: value
        }
        let resp = await this.$store.dispatch('deleteCrmFollowUp', deleteRe)
        if (resp.data.status === 'SUCCESS') {
          this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
          this.closeDialog()
          this.dialogShow = false
          await this.crmFollowUpList()
        } else {
          this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
          this.dialogShow = false
          this.closeDialog()
        }
      },
      editCrmFollowUp(data) {
        this.$refs.openDialog.editCrmFollowUp(data)
      },
      formatContactNumber(num) {
        if (!num) return ''
        const clean = num.toString().replace(/\D/g, '').substring(0, 10)
        return clean
      },
      exportCSV() {
        this.$refs.po.exportCSV()
      },
      // exportCSV() {
      //   let data = {
      //     columnList: this.columnList
      //   }
      //   axios({
      //     url: globalKey + '/fileDownload/excelReportAccount/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/CRM Follow-up List' + '/' + this.$store.getters.fyId + '/' + data.columnList,
      //     method: 'get',
      //     headers: {
      //       'Accept': 'application/vnd.ms-excel',
      //       'Authorization': localStorage.token
      //     },
      //     responseType: 'blob'
      //   }).then((response) => {
      //     const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
      //     const link = document.createElement('a')
      //     const contentDisposition = response.headers['content-disposition']
      //     let fileName = 'crmFollowUpList.xlsx'
      //     if (contentDisposition) {
      //       const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
      //       if (fileNameMatch && fileNameMatch.length === 2) {
      //         fileName = fileNameMatch[1]
      //       }
      //     }
      //     link.href = url
      //     link.setAttribute('download', fileName)
      //     document.body.appendChild(link)
      //     link.click()
      //     link.remove()
      //     window.URL.revokeObjectURL(url)
      //   })
      // },
      columnNames() {
        this.columnList = ''
        for (let i = 0; i < this.$refs.po.columns.length; i++) {
          if (this.$refs.po.columns[i].header && this.$refs.po.columns[i].header !== 'Action' && this.$refs.po.columns[i].header !== 'S.n') {
            this.columnList += this.$refs.po.columns[i].header + ','
          }
        }
        this.columnList = this.columnList.slice(0, -1)
      },
      async crmFollowUpList() {
        this.loading = true
        try {
          let res = await this.$store.dispatch('loadTodayCrmFollowUpList')
          return res
        } finally {
          this.loading = false
        }
      },
      openRemarks(data) {
        this.remarks = data.remarks
        this.remarks1 = data.remarks1
        this.remarks2 = data.remark2
        this.dialogVisible = true
        this.productName = data.products.join(', ')
        this.rate = data.rate
      },
      closeRemarks() {
        this.dialogVisible = false
      },
      openDialog(id) {
        this.dialogShow = true
        this.accountId = id
      },
      closeDialog() {
        this.dialogShow = false
      },
      cancel() {
        this.dialogShow = false
      }
    },
    components: {
      Column,
      DataTable,
      Dialog,
      InputText,
      crmFollowUpDetailsDialog,
      Button,
      remarksDialog,
      Textarea
    }
  }
  </script>
  <style scoped>
/* Loading Overlay Styles */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.85);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.spinner {
  width: 60px;
  height: 60px;
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  animation: spin 1.5s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-overlay h4 {
  font-size: 1.5rem;
  color: #2c3e50;
}
</style>




// WEBPACK FOOTER //
// crmTodayFollowUp.vue?6c76090a